import { dehydrate, hydrate, type DehydratedState, type QueryClient, type QueryKey } from "@tanstack/react-query";

/** Avoid refetching server-rendered public content immediately after hydration. */
export const PUBLIC_QUERY_STALE_TIME = 60_000;

/** Never serialize admin, preview, session, or permission queries into public HTML. */
export function isPublicQueryKey(key: QueryKey): boolean {
  if (key[0] === "content") return key[1] === "public" || key[1] === "readiness";
  if (key[0] === "blog") return key[1] === "published" || key[1] === "post";
  if (key[0] === "projects") return key[1] === "published";
  return key[0] === "media" && (key[1] === "realisaties" || key[1] === "opbouw");
}

export function dehydratePublicQueries(client: QueryClient): DehydratedState {
  return dehydrate(client, {
    shouldDehydrateQuery: (query) => query.state.status === "success" && isPublicQueryKey(query.queryKey),
    shouldDehydrateMutation: () => false,
  });
}

export function hydratePublicQueries(client: QueryClient, state: DehydratedState): void {
  hydrate(client, state);
}

/** The router transports a JSON string so its serializable type contract stays strict. */
export function hydrateSerializedPublicQueries(client: QueryClient, serialized: string): void {
  const state: DehydratedState = JSON.parse(serialized);
  hydratePublicQueries(client, state);
}